/**
 * What the pay page shows beside Paddle's checkout frame: the plan, in our own words, and the
 * amounts Paddle will charge, read from Paddle's own checkout events so that they match what
 * the checkout charges - in the customer's currency, tax included.
 */
export var PLAN_LABELS = {
  editing: 'Premium Editing',
  translation: 'Premium with Translation'
};
var INTERVAL_LABELS = {
  monthly: 'Monthly',
  yearly: 'Yearly'
};

// Paddle names billing cycles by period; the links name them by interval.
var PADDLE_INTERVALS = {
  month: 'monthly',
  year: 'yearly'
};

/** A checkout with no plan named adds a payment method to the trial, which bills editing monthly. */
export var TRIAL_PLAN = {
  plan: 'editing',
  interval: 'monthly'
};
export var planLabel = function planLabel(plan) {
  return PLAN_LABELS[plan] || PLAN_LABELS.editing;
};
export var intervalLabel = function intervalLabel(interval) {
  return INTERVAL_LABELS[interval] || INTERVAL_LABELS.monthly;
};

/**
 * The amounts in a Paddle.js checkout event (`checkout.loaded`, `checkout.updated`), or null
 * until Paddle has sent them.
 */
export var pricesFromCheckout = function pricesFromCheckout(data) {
  var _data$items, _data$recurring_total, _data$recurring_total2, _item$recurring_total, _data$totals, _data$totals$tax, _item$billing_cycle;
  var item = data === null || data === void 0 || (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items[0];
  var recurring = (_data$recurring_total = data === null || data === void 0 || (_data$recurring_total2 = data.recurring_totals) === null || _data$recurring_total2 === void 0 ? void 0 : _data$recurring_total2.total) !== null && _data$recurring_total !== void 0 ? _data$recurring_total : item === null || item === void 0 || (_item$recurring_total = item.recurring_totals) === null || _item$recurring_total === void 0 ? void 0 : _item$recurring_total.total;
  if (!(data !== null && data !== void 0 && data.currency_code) || (data === null || data === void 0 || (_data$totals = data.totals) === null || _data$totals === void 0 ? void 0 : _data$totals.total) === undefined || recurring === undefined) {
    return null;
  }
  return {
    currency: data.currency_code,
    dueToday: data.totals.total,
    tax: (_data$totals$tax = data.totals.tax) !== null && _data$totals$tax !== void 0 ? _data$totals$tax : 0,
    recurring: recurring,
    interval: PADDLE_INTERVALS[item === null || item === void 0 || (_item$billing_cycle = item.billing_cycle) === null || _item$billing_cycle === void 0 ? void 0 : _item$billing_cycle.interval] || null
  };
};
export var formatAmount = function formatAmount(amount, currency) {
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(amount);
  } catch (_unused) {
    return "".concat(amount, " ").concat(currency);
  }
};